<template>
  <div class="component">
    <div class="column register_column">
      <h2>{{ scopedStrings.title }}</h2>
      <table>
        <tr class="register" v-for="register in registers" :key="register.id">
          <td class="label">{{ register.name }}</td>
          <td class="value">{{ register.value_hex}}</td>
          <td class="value">{{ register.value_dec}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      scopedStrings: {
        type: Object,
        required: true
      },
      initialValue: {
        required: true
      }
    },
    data () {
      return {
        registers: this.initialValue
      }
    },
    methods: {
      update (newValue) {
        this.registers = newValue;
      },
      padHex(number, width) { // add prefix of zero to the number
        var result = number ? number.toString(16) : '0';
        while (result.length < width) {
          result = '0' + result;
        }
        return result;
      }
    }
  }
</script>

<style scoped>
  .component {
    font-size: 14px;
  }

  .register {
    display: flex;
  }

  .register > .label {
    width: 30px;
    margin-right: 8px;
  }

  .register span {
    padding-top: 2px;
    padding-bottom: 2px;
  }
</style>
